import { apiFetch } from '../apiFetch'

export const putDisplayInQueue = async (payload) => {
  return await apiFetch({
    method: 'POST',
    path: `/dashboards/${payload.id}`,
    payload
  })
}
